<template>
  <v-card class="mb-4" elevation="2">
    <v-card-text>
      <h3>Zusammenfassung</h3>
      <p>{{ participantCount }} Teilnehmer*in(nen) × {{ amount.amount }}€ = {{ participantCount * amount.amount }}€</p>
      <p v-if="wantShirts && shirtCount > 0">{{ shirtCount }} T-Shirt(s) × 15€ = {{ shirtCount * 15 }}€</p>
      <p v-if="wantShirts && shirtCount > 0">Versand: {{ packageFee.amount }}€</p>
      <v-divider class="my-2"></v-divider>
      <h2>Gesamt: {{ totalAmount }}€</h2>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'SummaryCard',
  props: {
    participantCount: {
      type: Number,
      required: true
    },
    amount: {
      type: Object,
      required: true
    },
    wantShirts: {
      type: Boolean,
      default: false
    },
    shirtCount: {
      type: Number,
      default: 0
    },
    packageFee: {
      type: Object,
      required: true
    }
  },
  computed: {
    totalAmount() {
      let total = this.participantCount * this.amount.amount;
      if (this.wantShirts && this.shirtCount > 0) {
        total += this.shirtCount * 15;
        total += this.packageFee.amount;
      }
      return total;
    }
  }
}
</script>
